import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  close(event) {
    event.preventDefault();
    const modal = this.element.closest(".fixed.inset-0");
    if (modal) {
      modal.remove();
    }
  }
}

